module.exports = __webpack_public_path__ + "img/creators-underline.0aba524e.svg";